import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import integrationsSAService from 'services/superadmin/integrationsSAService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Название'
    },
    {
        key: 'apiKey',
        label: 'API Key'
    },
    {
        key: "isActive",
        label: "Статус",
        formatter: (v) => !!v ? 'Активный' : 'Неактивный'
    },
    TableColumns.createdDate,
]

export const IntegrationList = () => {
    const [data, loadData, loading] = useRemoteResource(integrationsSAService.getAll, "");

    const onDelete = async (u) => {
        await integrationsSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Интеграции">
            <AppAdminTable
                columnConfig={listConfig}
                data={data || []}
                onDelete={onDelete}
                loading={loading}
            />
        </ListPage>
    );
}
